import { List, Record } from 'immutable'

export const ActiveProTrackLevelRecord = Record({
  id: null,
  userProTrackLevelId: null,
  name: null,
  proTrackName: null,
  history: List(),
  preSurveyLink: null,
  postSurveyLink: null,
  startDate: null,
  endSurveyRequested: null,
  stopped: null,
  finished: null,
  completedCount: 0,
  streakMax: 0,
  beginSurveySubmitted: null,
  endSurveySubmitted: null,
  autoEnroll: null,
})

export default class ActiveProTrackLevel extends ActiveProTrackLevelRecord {}
